import * as RiIcons from "react-icons/ri";

import * as GiIcons from "react-icons/gi";
import dashboardB from "../../assets/DigitalMarketing/image/Menu/dashboard_b.svg";
import dashboardW from "../../assets/DigitalMarketing/image/Menu/dashboard_w.svg";
import masters from "../../assets/DigitalMarketing/image/masters.svg";
import leadB from "../../assets/DigitalMarketing/image/Menu/lead_b.svg";
import leadW from "../../assets/DigitalMarketing/image/Menu/lead_w.svg";
import integrationB from "../../assets/DigitalMarketing/image/Menu/integration_b.svg";
import integrationW from "../../assets/DigitalMarketing/image/Menu/integration_w.svg";
import sourceB from "../../assets/DigitalMarketing/image/Menu/source_b.svg";
import sourceW from "../../assets/DigitalMarketing/image/Menu/source_w.svg";
import roleB from "../../assets/DigitalMarketing/image/Menu/role_b.svg";
import roleW from "../../assets/DigitalMarketing/image/Menu/role_w.svg";
import permissionB from "../../assets/DigitalMarketing/image/Menu/permission_b.svg";
import permissionW from "../../assets/DigitalMarketing/image/Menu/permission_w.svg";
import userB from "../../assets/DigitalMarketing/image/Menu/userManage_b.svg";
import userW from "../../assets/DigitalMarketing/image/Menu/userManage_w.svg";
import reportsB from "../../assets/DigitalMarketing/image/Menu/reports_b.svg";
import reportsW from "../../assets/DigitalMarketing/image/Menu/reports_w.svg";

import settingsB from "../../assets/DigitalMarketing/image/Menu/settings_b.svg";
import settingsW from "../../assets/DigitalMarketing/image/Menu/settings_w.svg";
import wellnessB from "../../assets/DigitalMarketing/image/Menu/wellness_b.svg";
import wellnessW from "../../assets/DigitalMarketing/image/Menu/wellness_w.svg";
import consultantB from "../../assets/DigitalMarketing/image/consultantB.svg";
import consultantW from "../../assets/DigitalMarketing/image/consultantW.svg";
import patinetListB from "../../assets/DigitalMarketing/image/patient_listB.svg";
import patinetListW from "../../assets/DigitalMarketing/image/patient_listW.svg";
import appointmentB from "../../assets/DigitalMarketing/image/appointmentB.svg";
import appointmentW from "../../assets/DigitalMarketing/image/appointmentW.svg";
import invoicesB from "../../assets/DigitalMarketing/image/invoicesB.svg";
import invoicesW from "../../assets/DigitalMarketing/image/invoicesW.svg";

import { FaUserClock } from "react-icons/fa";

// import * as AiIcons from "react-icons/ai"

export const SidebarData = [
  {
    title: "Home",
    path: "/",
    name: "dashboard",
    roles: ["super_admin", "branch", "receptionist", "pharmacist", "nurse"],
    icon1: <img src={dashboardW} className="side-icon" alt="menu" />,
    icon: <img src={dashboardB} className="side-icon" alt="menu" />,
    iconClosed: <RiIcons.RiArrowDownSFill className="side-icon" />,
    iconOpened: <RiIcons.RiArrowUpSFill className="side-icon" />,
    subNav: [
      {
        title: "Dashboard",
        path: "/",
        name: "dashboard",
        roles: ["super_admin", "branch", "receptionist", "pharmacist", "nurse"],
      },
      {
        title: "Mimo Konnect",
        path: "tech-bridge",
        name: "dashboard",
        roles: ["super_admin", "branch"],
      },
      // {
      //   title: "Mimo Analytics",
      //   path: "dashboard/mimo-analytics",
      //   name: "dashboard",
      //   icon: <MdIcons.MdOutlineAmpStories className="side-icon" />,
      // },
      {
        title: "Social Media Analytics",
        path: "socialmedia-analytics",
        name: "dashboard",
        // icon: <img src={reportsB} className="side-icon" alt="menu" />,
        // icon1: <img src={reportsW} className="side-icon" alt="menu" />,
        roles: ["super_admin", "branch"],
      },
      // {
      //   title: "Spotlight Analytics",
      //   path: "spotlight-analytics",
      //   name: "spotlight",
      //   icon: <img src={reportsB} className="side-icon" alt="menu" />,
      //   icon1: <img src={reportsW} className="side-icon" alt="menu" />,
      //   roles: ["super_admin", "branch"],
      // },
    ],
  },
  {
    title: "Masters",
    path: "locations",
    name: "medicine_master",
    icon1: <img src={masters} className="side-icon" alt="menu" />,
    icon: <img src={masters} className="side-icon" alt="menu" />,
    iconClosed: <RiIcons.RiArrowDownSFill className="side-icon" />,
    iconOpened: <RiIcons.RiArrowUpSFill className="side-icon" />,
    roles: ["super_admin", "receptionist"],
    subNav: [
      {
        title: "Branches",
        path: "locations",
        name: "medicine_master",
        roles: ["super_admin"],
      },
      {
        title: "Medicine master",
        path: "medicine-master",
        name: "medicine_master",
        roles: ["super_admin", "receptionist"],
      },
      {
        title: "Procedure Templates",
        path: "procedure-templates",
        name: "medicine_master",
        roles: ["super_admin", "receptionist"],
      },
      {
        title: "EHR Templates",
        path: "ehr-templates",
        name: "medicine_master",
        roles: ["super_admin", "receptionist"],
      },

      {
        title: "Customer Journey",
        path: "customer-journey",
        name: "customer_journey",
        roles: ["super_admin", "receptionist"],
      },
      {
        title: "Treatment Journey",
        path: "treatment-journey-stages",
        name: "ivf_journey_stages",
        roles: ["super_admin", "receptionist"],
      },
    ],
  },
  {
    title: "Masters",
    path: "medicine-master",
    name: "medicine_master",
    icon1: <img src={masters} className="side-icon" alt="menu" />,
    icon: <img src={masters} className="side-icon" alt="menu" />,
    iconClosed: <RiIcons.RiArrowDownSFill className="side-icon" />,
    iconOpened: <RiIcons.RiArrowUpSFill className="side-icon" />,
    roles: ["branch"],
    subNav: [
      {
        title: "Medicine master",
        path: "medicine-master",
        name: "medicine_master",
        roles: ["branch"],
      },
      {
        title: "Procedure Templates",
        path: "procedure-templates",
        name: "medicine_master",
        roles: ["branch"],
      },
      {
        title: "EHR Templates",
        path: "ehr-templates",
        name: "medicine_master",
        roles: ["branch"],
      },

      {
        title: "Customer Journey",
        path: "customer-journey",
        name: "customer_journey",
        roles: ["branch"],
      },
      {
        title: "Treatment Journey",
        path: "treatment-journey-stages",
        name: "ivf_journey_stages",
        roles: ["branch"],
      },
    ],
  },
  {
    title: "Lead Management",
    path: "lead-management",
    name: "digital_marketing",
    icon1: <img src={leadW} className="side-icon" alt="menu" />,
    icon: <img src={leadB} className="side-icon" alt="menu" />,
    roles: ["super_admin", "branch", "receptionist"],
  },
  // {
  //   title: "Medicine master",
  //   path: "medicine-master",
  //   name: "medicine_master",
  //   icon1: <img src={medW} className="side-icon" alt="menu" />,
  //   icon: <img src={medB} className="side-icon" alt="menu" />,
  // },
  {
    title: "Consultant List",
    path: "consultant-list",
    name: "digital_marketing",
    icon1: <img src={consultantW} className="side-icon" alt="menu" />,
    icon: <img src={consultantB} className="side-icon" alt="menu" />,
    roles: ["super_admin", "branch", "receptionist"],
  },

  {
    title: "Consultant Appointment",
    path: "consultant-appointment",
    name: "digital_marketing",
    icon1: <FaUserClock className="side-icon" />,
    icon: <FaUserClock className="side-icon" />,
    roles: ["super_admin", "branch", "receptionist"],
  },

  {
    title: "Consultant Expenses",
    path: "consultant-expenses",
    name: "digital_marketing",
    icon1: <img src={invoicesW} className="side-icon" alt="menu" />,
    icon: <img src={invoicesB} className="side-icon" alt="menu" />,
    roles: ["super_admin", "branch", "receptionist"],
  },

  {
    title: "Patient List",
    path: "patient-list",
    name: "digital_marketing",
    icon1: <img src={patinetListW} className="side-icon" alt="menu" />,
    icon: <img src={patinetListB} className="side-icon" alt="menu" />,
    roles: ["super_admin", "branch", "receptionist", "pharmacist", "nurse"],
  },

  {
    title: "Appointment List",
    path: "appointment-list",
    name: "digital_marketing",
    icon1: <img src={appointmentW} className="side-icon" alt="menu" />,
    icon: <img src={appointmentB} className="side-icon" alt="menu" />,
    roles: ["super_admin", "branch", "receptionist"],
  },

  {
    title: "Invoices",
    path: "invoice-list",
    name: "digital_marketing",
    icon1: <img src={invoicesW} className="side-icon" alt="menu" />,
    icon: <img src={invoicesB} className="side-icon" alt="menu" />,
    roles: ["super_admin", "branch"],
  },

  // {
  //   title: "Appointments",
  //   path: "appointment-index",
  //   name: "appointments",
  //   icon1: <img src={appointmentW} className="side-icon" alt="menu" />,
  //   icon: <img src={appointmentB} className="side-icon" alt="menu" />,
  //   roles:["branch"]
  // },

  {
    title: "Labs Management",
    path: "my-labs",
    name: "medicine_master",
    icon1: <img src={masters} className="side-icon" alt="menu" />,
    icon: <img src={masters} className="side-icon" alt="menu" />,
    iconClosed: <RiIcons.RiArrowDownSFill className="side-icon" />,
    iconOpened: <RiIcons.RiArrowUpSFill className="side-icon" />,
    roles: ["super_admin", "branch"],
    subNav: [
      {
        title: "My Labs",
        path: "my-labs",
        name: "medicine_master",
        roles: ["super_admin", "branch"],
      },
      // {
      //   title: "Prescribed Tests",
      //   path: "prescribed-tests",
      //   name: "medicine_master",
      // },
      {
        title: "Test Orders",
        path: "test-orders",
        name: "my-labs",
        roles: ["super_admin", "branch"],
      },
      {
        title: "Test Packages",
        path: "test-packages",
        name: "my-labs",
        roles: ["super_admin", "branch"],
      },
    ],
  },
  {
    title: "Care Packages",
    path: "care-packages",
    name: "care-packages",
    icon1: <GiIcons.GiHospitalCross className="side-icon" />,
    icon: <GiIcons.GiHospitalCross className="side-icon" />,
    roles: ["super_admin", "branch", "receptionist"],
  },
  {
    title: "Blood Test Collection",
    path: "blood-test-collection",
    name: "blood_test_collection",
    icon1: <img src={leadW} className="side-icon" alt="menu" />,
    icon: <img src={leadB} className="side-icon" alt="menu" />,
    roles: ["super_admin", "branch", "receptionist"],
  },
  // {
  //   title: "Potential Leads",
  //   path: "potential-leads",
  //   name: "potential_leads",
  //   icon1: <img src={leadW} className="side-icon" alt="menu" />,
  //   icon: <img src={leadB} className="side-icon" alt="menu" />,
  //   roles: ["branch"],
  // },
  {
    title: "Wellness Tips",
    path: "wellness-tips",
    name: "wellness",
    icon1: <img src={wellnessW} className="side-icon" alt="menu" />,
    icon: <img src={wellnessB} className="side-icon" alt="menu" />,
    roles: ["super_admin", "branch", "receptionist"],
  },
  {
    title: "Reminders",
    path: "reminder-index",
    name: "reminders",
    icon1: <FaUserClock className="side-icon" />,
    icon: <FaUserClock className="side-icon" />,
    roles: ["super_admin", "branch", "receptionist"],
  },
  {
    title: "Integrations",
    path: "integration",
    name: "integration",
    icon1: <img src={integrationW} className="side-icon" alt="menu" />,
    icon: <img src={integrationB} className="side-icon" alt="menu" />,
    roles: ["branch", "receptionist"],
  },
  {
    title: "Source Master",
    path: "source-master",
    name: "source_master",
    icon1: <img src={sourceW} className="side-icon" alt="menu" />,
    icon: <img src={sourceB} className="side-icon" alt="menu" />,
    roles: ["super_admin"],
  },
  {
    title: "Roles",
    path: "role-management",
    name: "user_management",
    icon1: <img src={roleW} className="side-icon" alt="menu" />,
    icon: <img src={roleB} className="side-icon" alt="menu" />,
    roles: ["super_admin"],
  },
  // {
  //   title: "Permission Management",
  //   path: "permission-management",
  //   name: "user_management",
  //   icon1: <img src={permissionW} className="side-icon" alt="menu" />,
  //   icon: <img src={permissionB} className="side-icon" alt="menu" />,
  //   roles: ["super_admin", "branch"],
  // },

  {
    title: "User Management",
    path: "user-management",
    name: "user_management",
    icon1: <img src={userW} className="side-icon" alt="menu" />,
    icon: <img src={userB} className="side-icon" alt="menu" />,
    roles: ["super_admin", "branch"],
  },

  // {
  //   title: "Treatment",
  //   path: "treatment",
  //   name: "treatment_types",
  //   icon1: <GiIcons.GiHospitalCross className="side-icon" />,
  //   icon: <GiIcons.GiHospitalCross className="side-icon" />,
  //   roles: ["super_admin", "branch"],
  // },

  {
    title: "Reports",
    path: "reports",
    name: "reports",
    icon1: <img src={reportsW} className="side-icon" alt="menu" />,
    icon: <img src={reportsB} className="side-icon" alt="menu" />,
    roles: ["super_admin", "branch", "receptionist"],
  },
  // {
  //   title: "Branches",
  //   path: "branches",
  //   name: "hospital_branch",
  //   icon: <img src={branch} className="side-icon" alt='menu'/>,
  // },
  {
    title: "Settings",
    path: "settings",
    name: "settings",
    hr: "true",
    roles: ["super_admin", "branch", "receptionist", "pharmacist", "nurse"],
    icon1: <img src={settingsW} className="side-icon" alt="menu" />,
    icon: <img src={settingsB} className="side-icon" alt="menu" />,
  },
];
